import { SystemText } from 'e4shared';
import React from 'react';

export const Loading = () => {
    return (
        <div style={{ padding: '100px 50%' }}>
            <div style={{ textAlign: 'center', width: '350px' }}>
                <i style={{ fontSize: '50px' }} className="fa fa-spin fa-cogs" />
                <div style={{ marginTop: '50px' }}>
                    <h4>{SystemText('Download/Message')}</h4>
                    <button onClick={() => window.close()} className="btn btn-primary" style={{ marginTop: '30px' }}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Loading;
